import { css } from "@emotion/react";

export const styles = {
  button: css`
    background-color: #0045b5;
    height: 48px;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 20px;
    width: fit-content;
    align-self: center;
    min-width: 190px;

    &:hover {
      background-color: #003399;
    }
  `
};
